// Add class if IE 11
var is_ie11 = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
if (is_ie11) {
    document.querySelector('body').classList.add('ie ie--11')
}

var scrollToAnchorOffSet = 80;

function jumpToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').scrollTop(aTag.offset().top);
    //$('html,body').animate({ scrollTop: aTag.offset().top }, 1);
}
function scrollToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}
function scrollToAnchorID(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}
function scrollToAnchorIDVanilla(aId) {
    console.log('anchor to : %o', aId);
    var anchor = document.querySelector('#' + aId);
    anchor.scrollIntoView()
}
function scrollToAnchorOffset(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}
function scrollToAnchorIDOffset(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}

function isNullUndefinedOrEmpty(val) {
    if (val === null || val === '' || val === undefined || val === 'undefined') {
        return true;
    } else {
        return false;
    }
}
function notNullUndefinedOrEmpty(val) {
    if (val === null || val === '' || val === undefined || val === 'undefined') {
        return false;
    } else {
        return true;
    }
}